import React, { useMemo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import CookiesBanner from '@/common/components/blocks/Modal/Common/CookiesBanner/CookiesBanner';
import ScrollToTop from '@/common/components/blocks/ScrollToTop/ScrollToTop';
import {
  ROUTE_AUTO_LOGIN,
  ROUTE_SCANBAT,
  ROUTE_STANDALONE,
} from '@/common/constants';
import { AddToContextProvider } from '@/common/contexts/AddToContext';
import { useAuth } from '@/common/contexts/AuthContext';
import { DefaultCartContextProvider } from '@/common/contexts/DefaultCartContext';
import { HistoryContextProvider } from '@/common/contexts/HistoryContext/HistoryContext';
import { MercureContextProvider } from '@/common/contexts/MercureContext/MercureContext';
import { MiniCartContextProvider } from '@/common/contexts/MiniCartContext/MiniCartContext';
import { ModalContextProvider } from '@/common/contexts/ModalContext';
import NodesTreeContextProvider from '@/common/contexts/NodesTreeContext/NodesTreeContext';
import { PathContextProvider } from '@/common/contexts/PathContext';
import { RemoveFromContextProvider } from '@/common/contexts/RemoveFromContext';
import { StockContextProvider } from '@/common/contexts/StockContext';
import { TagManagerContextProvider } from '@/common/contexts/TagManagerContext';
import { WishlistsContextProvider } from '@/common/contexts/WishlistsContext';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';
import { NODES_DEPTH } from '@/ebat/constants';
import { BannerContextProvider } from '@/ebat/contexts/BannerContext';
import { ModalIAContextProvider } from '@/ebat/contexts/ModalIAContext';
import EbatV2Navigation from '@/ebat/router/EbatV2Navigation/EbatV2Navigation';

import withBuild from '../hoc/build/withBuild';
import Routes from './routes';

const RouterEbat = () => {
  const { isLoggedIn, user } = useAuth();

  const isScanbat = useMemo(
    () => window.location.pathname.includes(ROUTE_SCANBAT),
    [],
  );

  /**
   * Check if route is standalone mode
   * @type {boolean}
   */
  const isStandalone = useMemo(
    () => window.location.pathname.includes(ROUTE_STANDALONE),
    [],
  );

  // const [isOpenProfileModal, setIsOpenProfileModal] = useState(false);

  /**
   * Close profile modal
   * @type {function}
   */
  // TODO: Désactivé pour l'instant (demande du client)
  // const closeProfileModal = useCallback(() => {
  //   setIsOpenProfileModal(false);
  // }, []);

  // TODO: Désactivé pour l'instant (demande du client)
  // useEffect(() => setIsOpenProfileModal(!isCompleteProfile), [
  //   isCompleteProfile,
  // ]);

  // Application blocked until we receive ACL
  // Only when user is connected
  if (
    user?.functionality_accesses === undefined &&
    isLoggedIn &&
    !window.location.pathname.includes(ROUTE_AUTO_LOGIN)
  ) {
    return <PageLoader className="general-page" />;
  }

  return (
    <Router>
      <ScrollToTop />
      <HistoryContextProvider>
        <MercureContextProvider>
          <TagManagerContextProvider>
            <DefaultCartContextProvider isLoggedIn={isLoggedIn}>
              <PathContextProvider>
                {/* Context RemoveFromContextProvider and AddToContextProvider are add here */}
                {/* because of HOC withCarts, withCart and context DefaultCartContextProvider dependencies */}
                <RemoveFromContextProvider isLoggedIn={isLoggedIn}>
                  <MiniCartContextProvider>
                    <StockContextProvider isLoggedIn={isLoggedIn}>
                      <AddToContextProvider
                        isLoggedIn={isLoggedIn}
                        isScanBat={isScanbat}
                      >
                        <WishlistsContextProvider isLoggedIn={isLoggedIn}>
                          <ModalContextProvider>
                            <ModalIAContextProvider>
                              <BannerContextProvider>
                                <NodesTreeContextProvider
                                  depth={isLoggedIn ? NODES_DEPTH : null}
                                >
                                  <EbatV2Navigation>
                                    <Routes />
                                    {!isScanbat && !isStandalone && (
                                      <CookiesBanner />
                                    )}
                                  </EbatV2Navigation>
                                </NodesTreeContextProvider>
                              </BannerContextProvider>
                            </ModalIAContextProvider>
                          </ModalContextProvider>
                        </WishlistsContextProvider>
                      </AddToContextProvider>
                    </StockContextProvider>
                  </MiniCartContextProvider>
                </RemoveFromContextProvider>
              </PathContextProvider>
            </DefaultCartContextProvider>
          </TagManagerContextProvider>
        </MercureContextProvider>
      </HistoryContextProvider>
    </Router>
  );
};

RouterEbat.defaultProps = {};

RouterEbat.propTypes = {};

export default withBuild(RouterEbat);
